export const name = 'interactions' as const

export const HasInteractionsRegistrySym = Symbol('HasInteractionsRegistry')
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
